import Common from '../../../Common';
import Connector, { FlowConnector } from './flow/Connector';
import Destination from './flow/Destination';
import Did from './flow/Did';
import Item, { FlowItem } from './flow/Item';

export interface BrowseFlow {
	id: id
	pbx_company_id: id
	name: string
	description: string
	autolayout: "0" | "1"
	auto_apply: "0" | "1"
}

export type Flow = BrowseFlow & {
	items: FlowItem[]
	connectors: FlowConnector[]
	dids: FlowDid[]
	pbx_dad_flows: {
		id: id
		name: string
	}[]
}

export interface FlowDid {
	id: id
	pbx_dad_flow_id: id
	pbx_did_id: id
}

interface Body {
	name: string
	description: string
	autolayout?: 0 | 1 | "0" | "1"
	auto_apply?: 0 | 1 | "0" | "1"
}

interface UpdateBody {
	name?: string
	description?: string
	autolayout?: 0 | 1 | "0" | "1"
	auto_apply?: 0 | 1 | "0" | "1"
}

export interface ApplyDryRunResponse {
	applicable: boolean
	changes: ApplyDryRunResponseChange[]
	redrawNeeded: boolean
}

export interface ApplyDryRunResponseChange {
	text: string
}

const Flow = class extends Common {
	item: InstanceType<typeof Item>;
	connector: InstanceType<typeof Connector>;
	did: InstanceType<typeof Did>;
	destination: InstanceType<typeof Destination>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.item = new Item(headers);
		this.connector = new Connector(headers);
		this.did = new Did(headers);
		this.destination = new Destination(headers);
	}

	browse = (companyId: id): CustomResponse<BrowseFlow[]> =>
		this.get(`/company/${companyId}/pbxdad/flow`)

	read = (companyId: id, id: id): CustomResponse<Flow> =>
		this.get(`/company/${companyId}/pbxdad/flow/${id}`)

	redraw = (companyId: id, id: id): CustomResponse<Flow> =>
		this.get(`/company/${companyId}/pbxdad/flow/${id}/redraw`)

	apply = (companyId: id, id: id, dryRun = false): CustomResponse<ApplyDryRunResponse> =>
		this.get(`/company/${companyId}/pbxdad/flow/${id}/apply?dryRun=${dryRun ? 1 : 0}`)

	create = (companyId: id, body: Body) =>
		this.post(`/company/${companyId}/pbxdad/flow`, body)

	update = (companyId: id, id: id, body: UpdateBody) =>
		this.patch(`/company/${companyId}/pbxdad/flow/${id}`, body)

	delete = (companyId: id, id: id) =>
		this.doDelete(`/company/${companyId}/pbxdad/flow/${id}`)
}

export default Flow
